// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605211751/js/" + chunkId + "." + {"44":"1d15583a","225":"32692a85","481":"404a3adf","486":"db530206","770":"ec2ad5f9"}[chunkId] + ".0.29988010904954665.chunk.js";
};